import './policies.css'
import { Link } from 'react-router-dom'
import { privacyPolicy } from '../../utils/constants/PolicyContent'

const Policies = () => {

    return (
        <div className='mf-policy-section'>
            <div className="policy-header primary-bg-color py-3">
                <div className="policy-header-content">
                    <Link to={'/'}><img width={120} height={45} src={'logo'} alt="logo" /> </Link>
                </div>
            </div>
            <div className="py-4 policy-title-container bg-white">
                <strong className='w-700 text-capitalize text-sec-color policy-title'>Privacy policy</strong>
            </div>
            <div className="mf-policy-content-container mb-4 mt-1">
                <p className="mf-policy-content font-14 text-primary-color p-3" dangerouslySetInnerHTML={{ __html: privacyPolicy }} />
            </div>
        </div>
    )
}

export default Policies